// Workaround for bug https://github.com/marmelab/react-admin/issues/2129
import { put, takeEvery } from 'redux-saga/effects'
import { destroy } from 'redux-form'

export default function* resetForm() {
  yield takeEvery('RA/RESET_FORM', function*() {
    yield put(destroy('record-form'))
  })
}
